import { useHistory } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-uikit/Typography";
import { useListEvents } from "../hooks/useListEvents";
import type { Event } from "../types/event";
import { EventItem } from "./EventItem";
import { SeeMoreLink } from "./common/SeeMoreLink";
import { SkeletonLoader } from "./common/SkeletonLoader";

export const EventsWrapper = () => {
  const { isLoading, data } = useListEvents();
  const history = useHistory();

  const events = (data?.records || []).slice(0, 2) as Event[];

  return (
    <div>
      <div className="my-3">
        <Typography.BodySm weight="medium" color="text-tertiary">
          {t("help_widget.explore_page.events")}
        </Typography.BodySm>
      </div>
      <div>
        {isLoading ? (
          <SkeletonLoader
            rows={2}
            height="80px"
            wrapperClassName="px-2"
            loaderClassName="bg-primary"
          />
        ) : (
          events.map((event: Event) => (
            <EventItem key={event.id} event={event} showArrowIcon />
          ))
        )}
      </div>
      <div className="pt-2">
        <SeeMoreLink onClick={() => history.push("/events")} />
      </div>
    </div>
  );
};
